// ICONS
export const ICONS = {
  save: "fluent:save-28-filled",
  cancel: "carbon:unsaved",
};

// MODULES
export const MODULES = [
  // Dashboard
  { module: "dashboard", section: "dashboard" },

  // Entidades
  { module: "asset", label: "assets", section: "entities" },
  { module: "component", label: "components", section: "entities" },
  { module: "structure", label: "structures", section: "entities" },
  { module: "task", label: "tasks", section: "entities" },
  { module: "taskGroup", label: "taskGroups", section: "entities" },
  { module: "supply", label: "supplies", section: "entities" },
  { module: "provider", label: "providers", section: "entities" },

  // Operatividad
  { module: "workRequest", label: "workRequests", section: "operability" },
  { module: "workRequestTask", label: "workRequestTasks", section: "operability" },
  { module: "program", label: "programs", section: "operability" },
  { module: "meter", label: "meters", section: "operability" },
  { module: "reading", label: "readings", section: "operability" },
  { module: "plannedTask", label: "plannedTasks", section: "operability" },
  { module: "workOrder", label: "workOrders", section: "operability" },
  { module: "workOrderTask", label: "workOrderTasks", section: "operability" },
  { module: "equipmentStop", label: "equipmentStops", section: "operability" },
  { module: "scheduledOperation", label: "scheduledOperations", section: "operability" },

  // Inventario
  { module: "voucher", label: "vouchers", section: "inventory" },
  { module: "voucherType", label: "voucherTypes", section: "inventory" },

  // Informes
  { module: "reports", section: "reports" },

  // Configuraciones
  { module: "systemConfiguration", section: "configurations" },
  { module: "labels", section: "configurations" },
  { module: "user", label: "users", section: "configurations" },
  { module: "role", label: "userRoles", section: "configurations" },
  { module: "workTeam", label: "workTeams", section: "configurations" },
  { module: "currency", label: "currencies", section: "configurations" },
  { module: "exchangeRate", label: "exchangeRates", section: "configurations" },
  { module: "category", label: "requestCategories", section: "configurations" },
  { module: "parameter", label: "parameters", section: "configurations" },
  { module: "parameterType", label: "parameterTypes", section: "configurations" },
  { module: "audit", section: "configurations" },
  { module: "dynamicConfiguration", section: "configurations" },
];

export const USER_TYPES = [
  { name: "internal", id: 0, labelKey: "internal" },
  { name: "external", id: 1, labelKey: "externalUser" },
];

export const USER_LICENSE_PLANNER = 0;
export const USER_LICENSE_OPERATIVE = 1;
export const USER_LICENSE_CLAIMS = 2;
export const USER_LICENSE_VIEW = 3;
export const USER_LICENSE_STOCK = 4;
export const USER_LICENSE_PROVIDER = 5;

export const USER_LICENSES = [
  { name: "plannerAdmin", id: USER_LICENSE_PLANNER },
  { name: "operative", id: USER_LICENSE_OPERATIVE },
  { name: "claims", id: USER_LICENSE_CLAIMS },
  { name: "view", id: USER_LICENSE_VIEW },
  { name: "stock", id: USER_LICENSE_STOCK },
  { name: "provider", id: USER_LICENSE_PROVIDER },
];

export const ENTERPRISE_LICENSE_STANDARD = 0;
export const ENTERPRISE_LICENSE_ENTERPRISE = 1;
export const ENTERPRISE_LICENSE_CORPORATE = 2;

export const ENTERPRISE_LICENSES = [
  { name: "Standard", id: ENTERPRISE_LICENSE_STANDARD },
  { name: "Enterprise", id: ENTERPRISE_LICENSE_ENTERPRISE },
  { name: "Corporate", id: ENTERPRISE_LICENSE_CORPORATE },
];

export const ENTERPRISE_ROLES = {
  admin: "Admin",
  viewer: "Viewer",
};

export const ENTERPRISE_STATUS_PENDING = 0;
export const ENTERPRISE_STATUS_IN_PROGRESS = 1;
export const ENTERPRISE_STATUS_COMPLETED = 2;
export const ENTERPRISE_STATUS_FAILED = 3;

export const ENTERPRISE_STATUS = [
  { name: "pending", id: ENTERPRISE_STATUS_PENDING },
  { name: "inProgress", id: ENTERPRISE_STATUS_IN_PROGRESS },
  { name: "completed", id: ENTERPRISE_STATUS_COMPLETED },
  { name: "failed", id: ENTERPRISE_STATUS_FAILED },
];

// ACTIONS
export const ACTION = {
  copy: "copy",
  print: "print",
  delete: "delete",
  add: "add",
  new: "new",
  edit: "edit",
  view: "view",
  more: "more",
  authorize: "authorize",
  accordance: "accordance",
  undelete: "undelete",
  resolved: "resolved",
  manager: "manager",
  attach: "attach",
  audit: "audit",
  close: "close",
};

// FIELD TYPE
export const FIELDTYPE = {
  boolean: 1,
  text: 2,
  number: 3,
  selectMultiple: 4,
  select: 5,
  dateTime: 6,
};

// FIELD TYPE NUMBER
export const FIELDNUMBERTYPE = {
  decimal: 1,
  integer: 2,
};

// FIELD TYPE COLOR
export const FIELDCOLORTYPE = {
  primary: 1,
  success: 2,
  warning: 3,
  error: 4,
  info: 5,
};

// FIELD TYPE TEXT
export const FIELDTEXTTYPE = {
  multiRow: 1,
  simple: 2,
};

// FIELD TYPE GROUP
export const FIELDGROUPTYPE = {
  group: 1,
  only: 2,
};

// FIELD TYPE DATE
export const FIELDDATETYPE = {
  dateTime: 1,
  date: 2,
};

// ENTITY TYPE
export const ENTITYTYPE = {
  provider: 1,
  supply: 2,
  location: 3,
  equipment: 4,
  task: 5,
  component: 6,
  user: 7,
  workRequest: 8,
  asset: 9,
  userClaims: 10,
  parameter: 11,
  reading: 12,
  program: 13,
  plannedTask: 14,
  workOrder: 15,
  woTask: 16,
  voucher: 17,
};

// USER NOTIFICATION (espeja el enum Consuman.Domain UserNotification)
export const USER_NOTIFICATION = {
  other: 0,
  newWorkRequest: 1,
  newWorkRequestComment: 2,
  workRequestPendingAuthorization: 3,
  workRequestUnauthorized: 4,
  workRequestResolved: 5,
  programEventTriggered: 6,
  programmedTaskNotice: 7,
  readingDeadlineExceeded: 8,
  readingOutOfRange: 9,
  minimumStockReached: 10,
  orderPointReached: 11,
  assignedToWorkOrder: 12,
  workOrderFinalized: 13,
};

// VOUCHER TYPE
export const VOUCHERTYPE = [
  { name: "stockEntry", id: 1 }, // Ingreso
  { name: "returnWithWorkOrder", id: 2 }, // Devolucion con OT
  { name: "stockOut", id: 3 }, // Egreso
  { name: "stockOutWithWorkOrder", id: 4 }, // Egreso con OT
  { name: "transfers", id: 5 }, // Transferencias
  { name: "internalShipment", id: 6 }, // Remito Interno
  { name: "stockEntryViaInternalShipment", id: 7 }, // Ingreso por Remito Interno
  { name: "adjustment", id: 8 }, // Ajuste
  { name: "toolIssuance", id: 9 }, // Entrega de Herramientas
  { name: "toolReturn", id: 10 }, // Devolucion de Herramientas
];

export const VOUCHERTYPENAME = Object.fromEntries(VOUCHERTYPE.map(({ name, id }) => [name, id]));

// VOUCHER COMPLETATION
export const VOUCHERCOMPLETATION = [
  { name: "notCompleted", id: 0 },
  { name: "partiallyCompleted", id: 1 },
  { name: "completed", id: 2 },
];

// TASK TYPE
export const TASKTYPE = [
  { name: "byTimeOrDate", id: 0 },
  { name: "multipleAnswer", id: 1 },
  { name: "singleAnswer", id: 2 },
  { name: "byReading", id: 3 },
  { name: "byCheck", id: 4 },
  { name: "byLocation", id: 5 },
  { name: "signature", id: 6 },
];

export const TASKTYPEENUM = {
  byTimeOrDate: 0,
  multipleAnswer: 1,
  singleAnswer: 2,
  byReading: 3,
  byCheck: 4,
  byLocation: 5,
  signature: 6,
};

// Tope de detalles por archivo en la importación de programas. Debe coincidir con
// ImportProgramsCommandHandler.MaxDetails, que es quien la valida en el backend.
export const PROGRAM_IMPORT_MAX_DETAILS = 500;

// TRIGGER TYPE
export const TRIGGERTYPE = [
  { name: "byTime", id: 0 },
  { name: "byFrequency", id: 1 },
  { name: "byTimeAndFrequency", id: 2 },
  { name: "byFrequencyAndFrequency", id: 3 },
  { name: "byEvent", id: 4 },
  { name: "byPredefinedDays", id: 5 },
];

// PROGRAM TIME UNIT
export const MAINTENANCETYPE = [
  { name: "workRequest", id: 1 },
  { name: "program", id: 2 },
  { name: "activityToDate", id: 3 },
];

// PROGRAM TIME UNIT
export const MAINTENANCETYPELIST = t => [
  { name: t("workRequest"), id: 1 },
  { name: t("program"), id: 2 },
  { name: t("activityToDate"), id: 3 },
];

export const WORKORDERTYPEFILTER = t => [
  { name: t("no"), id: 1 },
  { name: t("yes"), id: 2 },
];

export const MAINTENANCETYPENAME = {
  workRequest: 1,
  program: 2,
  activityToDate: 3,
};

// HUMAN RESOURCES TYPE
export const HRTYPE = [
  { name: t => t("user"), id: 0 },
  { name: t => t("workTeam"), id: 1 },
];

// HUMAN RESOURCES TYPE
export const WORKREQUESTSTATE = [
  { name: t => t("user"), id: 0 },
  { name: t => t("workTeam"), id: 1 },
];

// ACTIVITY TO DATE TYPE
export const ATDTYPE = [
  { name: t => t("byAsset"), id: 0 },
  { name: t => t("byComponent", { label: t("label:component") }), id: 1 },
];

// EVENT TRIGGER TYPE
export const EVENTTRIGGERTYPE = [
  { name: "byMeasurement", id: 0 },
  { name: "byFailure", id: 1 },
  { name: "byAnswer", id: 2 },
];

// PROGRAM TIME UNIT
export const PROGRAMTIMEUNIT = [
  { name: "day", id: 0 },
  { name: "week", id: 1 },
  { name: "month", id: 2 },
  { name: "year", id: 3 },
];

// WORK REQUEST STATE
export const WORKREQUESTSTATES = t => [
  { name: t("open"), id: 0 },
  { name: t("process"), id: 1 },
  { name: t("processWO"), id: 2 },
  { name: t("resolved"), id: 3 },
  { name: t("unauthorized"), id: 4 },
  { name: t("annulled"), id: 5 },
];

// CONDITION
export const CONDITION = [
  { name: "lessThan", id: 0 },
  { name: "lessEqualThan", id: 1 },
  { name: "equal", id: 2 },
  { name: "greaterEqualThan", id: 3 },
  { name: "greaterThan", id: 4 },
];

// CONDITION TYPE
export const CONDITIONTYPE = [
  { name: "lowerBound", id: 1 },
  { name: "upperBound", id: 2 },
  { name: "value", id: 3 },
];

// TYPE GROUP GENERATE WO
export const GROUPGENERATEWO = [
  { name: t => t("byEntity", { label: t("label:task").toLowerCase() }), id: 1 },
  { name: t => t("byActive"), id: 2 },
  { name: t => t("allTogether"), id: 3 },
];

// WORK ORDER TASK STATE
export const WORKORDERTASKSTATE = {
  notStarted: 1,
  inProgress: 2,
  finalized: 3,
  canceled: 4,
  deleted: 5,
};

// PLANNED TASK STATE
export const PLANNEDTASKSTATE = {
  planned: 0,
  hasWorkOrder: 1,
  deleted: 2,
  projection: 3,
};

export const PLANNEDTASKWOSTATE = [
  { id: 1, state: "notStarted", color: "warning" },
  { id: 2, state: "inProgress", color: "success" },
  { id: 3, state: "finalized", color: "info" },
  { id: 4, state: "canceled", color: "default", variant: "filled" },
  { id: 5, state: "deletedWO", color: "error" },
  { id: 6, state: "planned", color: "default" },
  { id: 7, state: "hasWorkOrder", color: "primary" },
  { id: 8, state: "deleted", color: "error" },
  { id: 9, state: "projection", color: "disabled" },
];

// WORK ORDER STATE
export const WORKORDERSTATE = {
  notStarted: 1,
  inProgress: 2,
  finalized: 3,
  closed: 4,
  deleted: 5,
};

// USER NOTIFICATIONS
export const USERNOTIFICATIONS = [
  // Work request
  { notification: "newWorkRequest", section: "workRequest" },
  { notification: "newWorkRequestComment", section: "workRequest" },
  { notification: "workRequestPendingAuthorization", section: "workRequest" },
  { notification: "workRequestUnauthorized", section: "workRequest" },
  { notification: "workRequestResolved", section: "workRequest" },

  // Program
  { notification: "programEventTriggered", section: "program" },
  { notification: "programmedTaskNotice", section: "program" },

  // Reading
  { notification: "readingDeadlineExceeded", section: "reading" },
  { notification: "readingOutOfRange", section: "reading" },

  // Supply
  { notification: "minimumStockReached", section: "supply" },
  { notification: "orderPointReached", section: "supply" },

  // Work order
  { notification: "assignedToWorkOrder", section: "workOrder" },
  { notification: "workOrderFinalized", section: "workOrder" },
];

// STOCK CONTROL MODES
export const WORKORDERSTOCKCONTROLMODE = [
  { name: "off", id: 0 },
  { name: "manual", id: 1 },
  { name: "automatic", id: 2 },
];

export const WORKORDERSTOCKCONTROLMODENAME = {
  off: 0,
  manual: 1,
  automatic: 2,
};

export const SOCIAL_NETWORKS = {
  googleWeb: "GoogleWeb",
  facebook: "Facebook",
  microsoft: "Microsoft",
};

// ACTIONS
export const ACTIONS = {
  unmodified: 0,
  create: 1,
  update: 2,
  delete: 3,
};

// ROOT LOCATION
export const ROOT_LOCATION = "019bffb9-ba78-1674-76b7-249d486cbd92";

// AI TRANSCRIPTION
export const AI_SOURCE_AUDIO = {
  action: 0,
  textField: 1,
  date: 2,
  time: 3,
  dateTime: 4,
  number: 5,
  workRequest: 6,
  workOrderTask: 7,
};

export const AI_ACTION = {
  unknown: 0,
  workRequest: 1,
};

// Maps a dynamic/custom field's FIELDTYPE to the value type the voice endpoint understands.
// "reference" / "referenceMultiple" fields are resolved server-side to a record (or records)
// through the existing list queries.
export const VOICE_TYPE_BY_FIELDTYPE = {
  [FIELDTYPE.boolean]: "boolean",
  [FIELDTYPE.text]: "string",
  [FIELDTYPE.number]: "number",
  [FIELDTYPE.dateTime]: "datetime",
  [FIELDTYPE.select]: "reference",
  [FIELDTYPE.selectMultiple]: "referenceMultiple",
};

export const LABEL_FIELDS = [
  "key",
  "taxNumber",
  "location",
  "locations",
  "equipment",
  "equipments",
  "component",
  "components",
  "task",
  "tasks",
  "attendant",
  "attendants",
  "supply",
  "supplies",
];
